import { render, staticRenderFns } from "./PinterestButton.vue?vue&type=template&id=704cad42"
import script from "./PinterestButton.vue?vue&type=script&lang=js"
export * from "./PinterestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704cad42')) {
      api.createRecord('704cad42', component.options)
    } else {
      api.reload('704cad42', component.options)
    }
    module.hot.accept("./PinterestButton.vue?vue&type=template&id=704cad42", function () {
      api.rerender('704cad42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/template/Resources/Private/Assets/Scripts/Components/PinterestButton.vue"
export default component.exports